import { render, staticRenderFns } from "./productBonusParam.vue?vue&type=template&id=53ece2ea&scoped=true&"
import script from "./productBonusParam.vue?vue&type=script&lang=js&"
export * from "./productBonusParam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ece2ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53ece2ea')) {
      api.createRecord('53ece2ea', component.options)
    } else {
      api.reload('53ece2ea', component.options)
    }
    module.hot.accept("./productBonusParam.vue?vue&type=template&id=53ece2ea&scoped=true&", function () {
      api.rerender('53ece2ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/product/proManage/productBonusParam.vue"
export default component.exports